var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgByn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2402_3609",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2402_3609)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H23V23H0V0Z",
    fill: "#73BE4A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V15.3333H23V0H0Z",
    fill: "#AF0100"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.3125,
    height: 23,
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.718734 0C1.11572 0 1.43748 0.429094 1.43748 0.958353C1.43748 1.48761 1.11572 1.91671 0.718734 1.91671C0.321839 1.91671 0 1.48761 0 0.958353C0 0.429094 0.321839 0 0.718734 0ZM3.59379 0C3.99069 0 4.31253 0.429094 4.31253 0.958353C4.31253 1.48761 3.99069 1.91671 3.59379 1.91671C3.19681 1.91671 2.87505 1.48761 2.87505 0.958353C2.87505 0.429094 3.19681 0 3.59379 0ZM1.43748 4.7917C1.43748 4.26236 1.11572 3.83335 0.718734 3.83335C0.321839 3.83335 0 4.26236 0 4.7917C0 5.32096 0.321839 5.74997 0.718734 5.74997C1.11572 5.74997 1.43748 5.32096 1.43748 4.7917ZM3.59379 3.83335C3.99069 3.83335 4.31253 4.26236 4.31253 4.7917C4.31253 5.32096 3.99069 5.74997 3.59379 5.74997C3.19681 5.74997 2.87505 5.32096 2.87505 4.7917C2.87505 4.26236 3.19681 3.83335 3.59379 3.83335ZM3.59379 17.25C3.99069 17.25 4.31253 17.679 4.31253 18.2084C4.31253 18.7376 3.99069 19.1666 3.59379 19.1666C3.19681 19.1666 2.87505 18.7376 2.87505 18.2084C2.87505 17.679 3.19681 17.25 3.59379 17.25ZM1.43748 18.2084C1.43748 17.679 1.11572 17.25 0.718734 17.25C0.321839 17.25 0 17.679 0 18.2084C0 18.7376 0.321839 19.1666 0.718734 19.1666C1.11572 19.1666 1.43748 18.7376 1.43748 18.2084ZM0.718734 21.0834C1.11572 21.0834 1.43748 21.5124 1.43748 22.0416C1.43748 22.571 1.11572 23 0.718734 23C0.321839 23 0 22.571 0 22.0416C0 21.5124 0.321839 21.0834 0.718734 21.0834ZM4.31253 22.0416C4.31253 21.5124 3.99069 21.0834 3.59379 21.0834C3.19681 21.0834 2.87505 21.5124 2.87505 22.0416C2.87505 22.571 3.19681 23 3.59379 23C3.99069 23 4.31253 22.571 4.31253 22.0416ZM2.15621 19.1666C2.5532 19.1666 2.87505 19.5957 2.87505 20.125C2.87505 20.6543 2.5532 21.0834 2.15621 21.0834C1.75933 21.0834 1.43748 20.6543 1.43748 20.125C1.43748 19.5957 1.75933 19.1666 2.15621 19.1666ZM2.87505 2.875C2.87505 2.34574 2.5532 1.91671 2.15621 1.91671C1.75933 1.91671 1.43748 2.34574 1.43748 2.875C1.43748 3.40426 1.75933 3.83335 2.15621 3.83335C2.5532 3.83335 2.87505 3.40426 2.87505 2.875ZM2.95405 11.5371L4.31253 13.4167V15.3333L4.34397 15.4223L2.22172 12.5903L0.314564 15.3333H0.000181198V13.4167L1.42497 11.5271L0.000181198 9.62587V7.6667H0.156723L2.20203 10.4966L4.2573 7.77092L4.31253 7.6667V9.58327L2.95405 11.5371ZM2.15621 5.74997C2.5532 5.74997 2.87505 6.17909 2.87505 6.70832C2.87505 7.23758 2.5532 7.6667 2.15621 7.6667C1.75933 7.6667 1.43748 7.23758 1.43748 6.70832C1.43748 6.17909 1.75933 5.74997 2.15621 5.74997ZM2.87505 16.2916C2.87505 15.7624 2.5532 15.3333 2.15621 15.3333C1.75933 15.3333 1.43748 15.7624 1.43748 16.2916C1.43748 16.8209 1.75933 17.25 2.15621 17.25C2.5532 17.25 2.87505 16.8209 2.87505 16.2916Z",
    fill: "#D0181A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H1.43748V1.91671H0V0ZM1.43748 3.83335H0V5.74997H1.43748V3.83335ZM0 7.6667H1.43748V9.58332H0V7.6667ZM1.43748 13.4167H0V15.3333H1.43748V13.4167ZM0 17.25H1.43748V19.1666H0V17.25ZM1.43748 21.0834H0V23H1.43748V21.0834ZM4.31253 21.0834H2.87505V23H4.31253V21.0834ZM4.31253 0H2.87505V1.91671H4.31253V0Z",
    fill: "#8F181A"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2402_3609)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2402_3609",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgByn);
export default __webpack_public_path__ + "static/media/BYN.a3af37ab5e5c7d8fcc81f82c936fa09c.svg";
export { ForwardRef as ReactComponent };